var exports = {
  "diffSquare": "diffSquare__kZ1s3g",
  "addition": "addition__3w3cWj",
  "deletion": "deletion__wmC-SA",
  "neutral": "neutral__T4nd7Z",
};

__webpack_require__.r(module.exports = exports);
